import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";
import { UserThumbnail } from "@kaltura/mediaspace-shared-ui";

export type UserMenuHeaderProps = {
    /** logged-in user's display name */
    userName: string;
    /** logged-in user's profile image */
    userThumbnailUrl: string;
};

/**
 * the user menu's first, non-interactive item - the logged-in user's profile image and name.
 * only shown for users with a profile image.
 * it has no tabindex, so the menu's keyboard navigation skips it.
 */
export const UserMenuHeader = ({ userName, userThumbnailUrl }: UserMenuHeaderProps) => (
    <StyledHeader className={"kms-ds-user-menu-header"} role={"none"}>
        <UserThumbnail name={userName} image={userThumbnailUrl} size={"small"} variant={"circle"} />
        <StyledName variant={"body2Highlight"}>{userName}</StyledName>
    </StyledHeader>
);
// tells the MUI MenuList not to give it the initial focus
UserMenuHeader.muiSkipListHighlight = true;

const StyledHeader = styled("li")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2, 1.5),
    marginBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.kaltura.palette.tone5}`,
    listStyle: "none",
}));

const StyledName = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.tone1,
    wordBreak: "break-word",
}));
